// Solomon Portal v1 — Supabase client singleton.
// SPA mode (PKCE), localStorage-backed session, automatic token refresh.

import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.generated';
import { env } from './env';

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      flowType: 'pkce',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    },
  },
);
